import { render } from "../templates/formModelAnswerStatement.html?vue&type=template&id=48a8d2b2"
import script from "./formModelAnswerStatement.vue?vue&type=script&lang=js"
export * from "./formModelAnswerStatement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__